import React, { useContext, useState } from "react";
import { Box, Button, IconButton, Tooltip } from "@mui/material";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import ApiPaginateSearch from "../../component/ApiPaginateSearch";
import ApiEndpoints from "../../network/ApiEndPoints";
import { CustomStyles } from "../../component/CustomStyle";
import CachedIcon from "@mui/icons-material/Cached";

import AddLeaveModal from "./AddLeaveModal";
import ApporveReject from "./ApporveReject";
import AuthContext from "../../store/AuthContext";
import DataFilter from "./Common/DataFilter";
import * as XLSX from "xlsx";
import DescriptionIcon from "@mui/icons-material/Description";
import { get } from "../../network/ApiController";
import { apiErrorToast } from "../../utils/ToastUtil";
import { ddmmyy } from "../../utils/DateUtils";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
};
const LeaveReq = () => {
  const [request, setRequest] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [leaveStatus, setLeaveStatus] = useState({});
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("");
  const [value, setValue] = useState("");
  const authCtx = useContext(AuthContext);
  const user = authCtx.user;
  let refresh;
  console.log("the query is:", query);
  const refreshFunc = () => {
    setQuery("");
    if (refresh) refresh();
  };
  const exportToExcel = async () => {
    try {
      const queryParams = "?page=1&paginate=1000"; // fetch enough data

      get(
        `${ApiEndpoints.GET_LEAVE}`,
        query,
        setRequest,
        (res) => {
          const data = res?.data?.data;

          if (!data || data.length === 0) {
            alert("No data to export");
            return;
          }

          // Get unique leave types
          const leaveTypes = [
            ...new Set(data.map((item) => item.leave_type?.toUpperCase())),
          ];

          // Group by Employee
          const groupedByEmployee = data.reduce((acc, item) => {
            if (!acc[item.emp_name]) acc[item.emp_name] = {};
            const type = item.leave_type?.toUpperCase();

            acc[item.emp_name][type] = {
              Reason: item.reason || "NA",
              From: item.from || "NA",
              To: item.to || "NA",
              Status: item.status?.toUpperCase(),
              Remark: item.remark || "NA",
              HandledBy: item.handled_by || "NA",
            };

            return acc;
          }, {});

          // Build final formatted array for Excel
          const formattedData = Object.keys(groupedByEmployee).map(
            (empName) => {
              let row = { "Employee Name": empName };

              leaveTypes.forEach((type) => {
                const leaveData = groupedByEmployee[empName][type] || {};
                row[`${type} - Reason`] = leaveData.Reason || "NA";
                row[`${type} - From`] = leaveData.From || "NA";
                row[`${type} - To`] = leaveData.To || "NA";
                row[`${type} - Status`] = leaveData.Status || "NA";
                row[`${type} - Remark`] = leaveData.Remark || "NA";
                row[`${type} - HandledBy`] = leaveData.HandledBy || "NA";
              });

              return row;
            }
          );

          // Create worksheet
          const worksheet = XLSX.utils.json_to_sheet(formattedData);

          // Auto-adjust column widths
          const columnWidths = Object.keys(formattedData[0]).map((key) => ({
            wch:
              Math.max(
                key.length,
                ...formattedData.map((row) => String(row[key] || "").length)
              ) + 2,
          }));
          worksheet["!cols"] = columnWidths;

          // Create workbook
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Leave Report");

          // Save file
          const fileName = `Leave_Report_${
            new Date().toISOString().split("T")[0]
          }.xlsx`;
          XLSX.writeFile(workbook, fileName);
        },
        (error) => {
          apiErrorToast(error);
          console.error("Error exporting to Excel:", error);
          alert("Failed to export data. Please try again.");
        }
      );
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alert("Failed to export data. Please try again.");
    }
  };

  // Alternative: If you want to export the currently displayed data (from apiData state)
  const exportCurrentDataToExcel = () => {
    if (apiData.length === 0) {
      alert("No data to export");
      return;
    }

    // Create worksheet from current apiData
    const worksheet = XLSX.utils.json_to_sheet(
      apiData.map((item) => ({
        "Employee ID": item.user_id,
        "Employee Name": item.emp_name,
        "Leave Type": item.leave_type,
        Session: item.session || "NA",
        From: item.from,
        To: item.to,
        Reason: item.reason,
        Remark: item.remark || "NA",
        Status: item.status,
      }))
    );

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leave Requests");

    // Generate Excel file
    const fileName = `Leave_Requests_${query || "All"}_${
      new Date().toISOString().split("T")[0]
    }.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  const [newLeaveReq, setNewLeaveReq] = useState({
    empId: "",
    employee: "",
    leaveType: "",
    from: "",
    to: "",
    reason: "",
  });

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setNewLeaveReq({ ...newLeaveReq, [name]: value });
  };

  const handleAddLeaveReq = (e) => {
    e.preventDefault();
    setApiData([
      ...apiData,
      { id: apiData.length + 1, ...newLeaveReq, status: "Pending" },
    ]);
    setNewLeaveReq({
      empId: "",
      employee: "",
      leaveType: "",
      from: "",
      to: "",
      reason: "",
    });
    setOpenModal(false);
  };

  const handleModalOpen = (leave, value) => {
    setValue(value);
    setSelectedLeave(leave);
    setConfirmationModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setConfirmationModal(false);
    setNewLeaveReq({
      empId: "",
      employee: "",
      leaveType: "",
      from: "",
      to: "",
      reason: "",
    });
  };

  const columns = [
    { name: "Employee ID", selector: (row) => row.user_id },
    { name: "Employee Name", selector: (row) => row.emp_name },
    { name: "Leave Type", selector: (row) => row.leave_type },
    {
      name: "Request Nature",
      selector: (row) => row?.request_nature?.toUpperCase(),
    },
    { name: "Session", selector: (row) => row.work_type.toUpperCase() || "" },
    { name: "From", selector: (row) => ddmmyy(row.from) },
    { name: "To", selector: (row) => ddmmyy(row.to) },
    { name: "Reason", selector: (row) => row.reason },
    { name: "Remark", selector: (row) => row.remark || "NA" },
    {
      name: "Status",
      selector: (row) => (
        <Box
          sx={{
            fontWeight: "bold",
            fontSize: "15px",
            textTransform: "uppercase",
            color:
              row.status === "PENDING"
                ? "orange"
                : row.status === "APPROVED"
                ? "green"
                : row.status === "REJECTED"
                ? "red"
                : "inherit", // fallback
          }}
        >
          {row.status || "Pending"}
        </Box>
      ),
    },

    user.role === "Admin" && {
      name: "Actions",
      selector: (row) => (
        <Box sx={{ display: "flex", gap: 2 }}>
          <ApporveReject data={row} refresh={refreshFunc} />
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <DataFilter
          ifemployeeFilter={user.role === "Admin"}
          setQuary={setQuery}
          setQuery={setQuery}
        />
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Tooltip title="Refresh">
            <IconButton
              aria-label="refresh"
              sx={{ color: "#0F52BA" }}
              onClick={() => refreshFunc(setQuery)}
            >
              <CachedIcon />
            </IconButton>
          </Tooltip>
          {user.role !== "Admin" && (
            <Button
              variant="contained"
              color="primary"
              sx={{
                backgroundColor: "#2F3B57",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
              onClick={() => setOpenModal(true)}
            >
              <AddCircleOutlineOutlinedIcon sx={{ marginRight: 1 }} /> Add Leave
            </Button>
          )}
        </Box>
      </Box>

      <ApiPaginateSearch
        apiEnd={ApiEndpoints.GET_LEAVE}
        columns={columns}
        apiData={apiData}
        setApiData={setApiData}
        tableStyle={CustomStyles}
        queryParam={query}
        returnRefetch={(ref) => {
          refresh = ref;
        }}
      />

      {/* Add Leave Modal */}
      <AddLeaveModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        refresh={refreshFunc}
      />
    </Box>
  );
};

export default LeaveReq;
